import { IntegrationChannelType, IntegrationType } from 'generated/graphql';
import {
  AppstoreFormModal,
  DelightedFormModal,
  DiscourseFormModal,
  EmailFormModal,
  FileUploadFormModal,
  FreshchatFormModal,
  FreshdeskFormModal,
  FrontFormModal,
  G2FormModal,
  KustomerFormModal,
  PlaystoreFormModal,
  QualtricsFormModal,
  StellaConnectFormModal,
  WebhookFormModal,
  ZendeskChatFormModal,
  ZendeskSupportFormModal,
} from '../components/IntegrationFormModals';
import { SnowflakeFormModal } from '../components/IntegrationFormModals/SnowflakeFormModal';

const ChannelTypeToFormModalMap: Record<
  string,
  (props: GetIntegrationFormModalBasedOnChannelTypeOptions) => JSX.Element
> = {
  [IntegrationChannelType.Appstore]: AppstoreFormModal,
  [IntegrationChannelType.Delighted]: DelightedFormModal,
  [IntegrationChannelType.Email]: EmailFormModal,
  [IntegrationChannelType.FileUpload]: FileUploadFormModal,
  [IntegrationChannelType.Freshchat]: FreshchatFormModal,
  [IntegrationChannelType.FreshDesk]: FreshdeskFormModal,
  [IntegrationChannelType.Front]: FrontFormModal,
  [IntegrationChannelType.G2]: G2FormModal,
  [IntegrationChannelType.Kustomer]: KustomerFormModal,
  [IntegrationChannelType.Playstore]: PlaystoreFormModal,
  [IntegrationChannelType.Snowflake]: SnowflakeFormModal,
  [IntegrationChannelType.Webhook]: WebhookFormModal,
  [IntegrationChannelType.StellaConnect]: StellaConnectFormModal,
  [IntegrationChannelType.ZendeskChat]: ZendeskChatFormModal,
  [IntegrationChannelType.ZendeskSupport]: ZendeskSupportFormModal,
  [IntegrationChannelType.Discourse]: DiscourseFormModal,
  [IntegrationChannelType.Qualtrics]: QualtricsFormModal,
};

interface GetIntegrationFormModalBasedOnChannelTypeOptions {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
}

export const getIntegrationFormModalBasedOnChannelType = ({
  channelType,
  integrationType,
}: GetIntegrationFormModalBasedOnChannelTypeOptions) => {
  const IntegrationFormModal = ChannelTypeToFormModalMap[channelType];

  if (!IntegrationFormModal) {
    return null;
  }

  return (
    <IntegrationFormModal
      integrationType={integrationType}
      channelType={channelType}
    />
  );
};
